import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'

import RouteLayout from '../../RouteLayout'
import Spinner from '../../common/Spinner'
import { CaptionTable } from '../../common/CaptionTable/CaptionTable'
import { eduCommissionsListActions } from '../../../redux/reducers/EduCommissions/eduCommissionsReducer'
import { organizationList } from '../../../redux/reducers/organization-list-reducer'
import styles from './styles.module.css'

const formatDate = (v) => v ? moment(v, 'DD.MM.YYYY hh:mm:ss').format('DD.MM.YYYY') : ''

const List = () => {
  const { orgId } = useParams()
  const dispatch = useDispatch()
  const history = useHistory()

  const auth = useSelector(state => state.auth.data)
  const list = useSelector(state => state.eduCommissions.list)
  const loader = useSelector(state => state.eduCommissions.loader)
  const orgList = useSelector(state => state.reports.orgList.data)

  const org = orgList?.find(o => String(o.idOrganization) === String(orgId))
  const orgListLength = orgList?.length || 0

  useEffect(() => {
    dispatch(eduCommissionsListActions.eduCommissionsListRequestStart({ org_id: orgId }))
  }, [dispatch, orgId])

  useEffect(() => {
    if (!orgListLength) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
  }, [dispatch, auth, orgListLength])

  const handleRowClick = (id) => {
    history.push(`/edu_commissions/${orgId}/${id}`)
  }

  const title = org?.orgName
    ? `Аттестационные комиссии — ${org.orgName}`
    : 'Аттестационные комиссии ОО'

  return (
    <RouteLayout title={title}>
      {loader
        ? <Spinner />
        : (
          <div className={styles.tableBlock}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№ п/п</th>
                  <th>Дата начала</th>
                  <th>Дата окончания</th>
                  <th>Телефон</th>
                  <th>Председатель</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index) => (
                  <tr key={item.id} onClick={() => handleRowClick(item.id)}>
                    <td>{index + 1}</td>
                    <td>{formatDate(item.start_date)}</td>
                    <td>{formatDate(item.end_date)}</td>
                    <td>{item.phone || ''}</td>
                    <td>{item.predsedatel_fio || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!list.length && !loader && <CaptionTable>Список пуст</CaptionTable>}
          </div>
        )
      }
    </RouteLayout>
  )
}

export default List
